import { render, staticRenderFns } from "./ChatbotProduct.vue?vue&type=template&id=4627ef32&scoped=true"
import script from "./ChatbotProduct.vue?vue&type=script&lang=js"
export * from "./ChatbotProduct.vue?vue&type=script&lang=js"
import style0 from "./ChatbotProduct.vue?vue&type=style&index=0&id=4627ef32&prod&scoped=true&lang=scss"
import style1 from "./ChatbotProduct.vue?vue&type=style&index=1&id=4627ef32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4627ef32",
  null
  
)

export default component.exports